<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6674 5C18.0314 9.04049 18.0314 14.9595 14.6674 19M10.9587 8.23077C13.007 10.3125 13.007 13.6875 10.9587 15.7692M6.19043 12L7.1102 11.0479C7.16622 10.9899 7.23793 10.9169 7.3098 10.9534C8.15836 11.3846 8.15836 12.6153 7.3098 13.0465C7.23793 13.083 7.16622 13.01 7.1102 12.952L6.19043 12Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
